// Configurações específicas para produção
export const PRODUCTION_CONFIG = {
  DOMAINS: {
    FRONTEND: import.meta.env.URL_BASE_FRONTEND || 'https://fotup.devonno.com.br',
    API: import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br',
    STORAGE: import.meta.env.URL_BASE_STORAGE || 'https://fotup-api.devonno.com.br' // Mesmo domínio do backend
  },
  HEALTH_ENDPOINTS: {
    FRONTEND: `${import.meta.env.URL_BASE_FRONTEND || 'https://fotup.devonno.com.br'}/health`,
    API: `${import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br'}/health`,
    STORAGE: `${import.meta.env.URL_BASE_STORAGE || 'https://fotup-api.devonno.com.br'}/health`
  },
  CORS_ORIGINS: [
    import.meta.env.URL_BASE_FRONTEND || 'https://fotup.devonno.com.br',
    import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br'
  ]
} as const;

// Função para verificar se estamos em produção
export const isProduction = (): boolean => {
  const isProd = import.meta.env.PROD || 
         window.location.hostname.includes('fotup.devonno.com.br') ||
         window.location.hostname.includes(import.meta.env.DOMAIN_BASE);
  
  // console.log('🔍 isProduction() - Verificação:', {
  //   'import.meta.env.PROD': import.meta.env.PROD,
  //   'hostname': window.location.hostname,
  //   'includes fotup.devonno.com.br': window.location.hostname.includes('fotup.devonno.com.br'),
  //   'DOMAIN_BASE': import.meta.env.DOMAIN_BASE,
  //   'includes DOMAIN_BASE': window.location.hostname.includes(import.meta.env.DOMAIN_BASE),
  //   'resultado': isProd
  // });
  
  return isProd;
};

// Função para obter a URL base da API baseada no ambiente
export const getApiBaseUrl = (): string => {
  const prodCheck = isProduction();
  let apiUrl: string;
  
  // SEMPRE verificar primeiro a variável de ambiente, independente do ambiente
  const envBackendUrl = import.meta.env.URL_BASE_BACKEND;
  
  if (envBackendUrl) {
    // Se a variável de ambiente está definida, usar ela
    apiUrl = envBackendUrl;
  } else if (prodCheck) {
    // Em produção sem variável de ambiente, usar a URL específica do backend
    apiUrl = 'https://fotup-api.devonno.com.br';
  } else {
    // Desenvolvimento - BACKEND INTEGRADO: usar localhost:3001
    apiUrl = 'http://localhost:3001';
  }
  
  // Remover barra final se existir para evitar barras duplas na construção da URL
  apiUrl = apiUrl.replace(/\/+$/, '');
  
  // Log para debug em produção
  if (prodCheck && typeof window !== 'undefined') {
    console.log('🔍 [getApiBaseUrl] Configuração:', {
      'isProduction': prodCheck,
      'URL_BASE_BACKEND env': envBackendUrl,
      'URL final': apiUrl,
      'hostname': window.location.hostname,
      'window.location.origin': window.location.origin
    });
  }
  
  return apiUrl;
};

// Função para obter a URL do storage baseada no ambiente
export const getStorageBaseUrl = (): string => {
  const prodCheck = isProduction();
  let storageUrl: string;
  
  if (prodCheck) {
    storageUrl = PRODUCTION_CONFIG.DOMAINS.STORAGE;
  } else {
    // Desenvolvimento
    storageUrl = import.meta.env.URL_BASE_STORAGE || 'http://localhost:5002';
  }
  
  console.log('💾 getStorageBaseUrl() - Configuração:', {
    'isProduction': prodCheck,
    'URL_BASE_STORAGE env': import.meta.env.URL_BASE_STORAGE,
    'PRODUCTION_CONFIG.DOMAINS.STORAGE': PRODUCTION_CONFIG.DOMAINS.STORAGE,
    'URL final': storageUrl
  });
  
  return storageUrl;
};